import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { heroContent } from '../../data/homeContent';

const HeroSection = ({ onExploreSolutions }) => {
  return (
    <div className="bg-[#51dcb1] text-white py-20 lg:py-32 relative overflow-hidden">
      {/* Animated Background Shapes */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large floating circles */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute top-20 right-20 w-24 h-24 bg-white/10 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 bg-white/5 rounded-full animate-ping" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 right-1/3 w-20 h-20 bg-white/15 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
        
        {/* Gradient orbs */}
        <div className="absolute top-1/3 left-1/2 w-60 h-60 bg-gradient-to-r from-white/20 to-transparent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-l from-white/15 to-transparent rounded-full blur-3xl animate-bounce" style={{ animationDelay: '1.5s' }}></div>
        
        {/* Floating geometric shapes */}
        <div className="absolute top-1/4 right-1/6 w-16 h-16 bg-white/10 rounded-lg rotate-45 animate-spin" style={{ animationDuration: '20s' }}></div>
        <div className="absolute bottom-1/3 left-1/6 w-12 h-12 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '0.8s' }}></div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Animated title with gradient text */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in bg-gradient-to-r from-white via-blue-50 to-white bg-clip-text text-transparent">
            {heroContent.title}
          </h1>
          
          {/* Animated subtitle */}
          <p className="text-lg md:text-xl lg:text-2xl mb-8 text-white/90 animate-fade-in" style={{ animationDelay: '0.3s' }}>
            {heroContent.subtitle}
          </p>
          
          {/* Enhanced CTA button with hover effects */}
          <div className="animate-fade-in" style={{ animationDelay: '0.6s' }}>
            <button 
              onClick={onExploreSolutions}
              className="group bg-white text-[#51dcb1] px-8 py-4 rounded-full font-semibold hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl relative overflow-hidden">
              <span className="relative z-10 flex items-center">
                Explore Solutions 
                <ArrowRightOutlined className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
              {/* Button background animation */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></div>
            </button>
          </div>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg className="w-full h-16 text-white" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
          <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
          <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
  );
};

export default HeroSection; 